// extracted by mini-css-extract-plugin
export var content = "_t5-1";
export var wrapper = "_t5-0";